import {MenuService} from '../services';
import {bindLoading} from './index';

export default {
    namespaced: true,
    state: {
        menus: []
    },

    mutations: {
        saveMenus(state, menus) {
            state.menus.splice(0);
            state.menus = [...menus];
        }
    },

    actions: {
        async getMenusAction({commit}) {
            await bindLoading(commit,
                async () => commit('saveMenus', await MenuService.getAll()), 'menu');
        },

        async removeMenuAction({commit, state}, menuId) {
            return await bindLoading(commit,
                async () => {
                    const res = await MenuService.remove(menuId);
                    if (res.success) {
                        commit('saveMenus', state.menus.filter(f => !res.instance.find(r => r === f.menuId)));
                    }
                    return res;
                }, 'menu');
        },

        async addMenuAction({commit, state}, item) {
            return await bindLoading(commit,
                async () => {
                    const res = await MenuService.insert(item);
                    if (res.success) {
                        commit('saveMenus', [...state.menus, res.instance]);
                    }
                    return res;
                }, 'menu');
        },

        async updateMenuAction({commit, state}, item) {
            return await bindLoading(commit,
                async () => {
                    const res = await MenuService.update(item);
                    if (res.success) {
                        const idx = state.menus.findIndex(m => m.menuId === item.menuId);
                        commit('saveMenus',
                            [
                                ...state.menus.filter((_, i) => i < idx),
                                res.instance,
                                ...state.menus.filter((_, i) => i > idx)
                            ]);
                    }
                    return res;
                }, 'menu');
        }
    }

}